

export class Quotes{
  
    createdAt: Date;
    quote: string;
    
}